import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxTextBoxModule,
    DxFormModule,
    DxValidatorModule,
    DxRadioGroupModule,
} from 'devextreme-angular';
import { getSizeQualifier } from 'src/app/services/screen.service';
import { CompleteAppointmentCommand } from '@services';
import { StagingLanePipe } from 'src/app/pipes/staging-lane.pipe';
import { ComplianceFormComponent } from '../compliance-form/compliance-form.component';
import { FormPopupComponent } from 'src/app/components/utils/form-popup/form-popup.component';
@Component({
    selector: 'complete-form',
    templateUrl: './complete-form.component.html',
    imports: [
        DxTextBoxModule,
        DxFormModule,
        DxValidatorModule,
        CommonModule,
        DxRadioGroupModule,
        ComplianceFormComponent,
        FormPopupComponent
    ],
    providers: [StagingLanePipe],
})
export class CompleteFormComponent {
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onSave = new EventEmitter();

    @ViewChild(ComplianceFormComponent, { static: false }) completeForm: ComplianceFormComponent;

    formData: CompleteAppointmentCommand = {} as CompleteAppointmentCommand;

    getSizeQualifier = getSizeQualifier;

    onPopupSaveClick(){
        this.onSave.emit();
    }

    onVisibleChange(visible: boolean) {
        this.visibleChange.emit(visible);
    }

    getData = () => new CompleteAppointmentCommand({ ...this.completeForm.getData() });
}
